import { ThermostatIcon } from './ThermostatIcon';

/**
 * author: Google
 * id 628D16E2-7E57-43CA-8451-012B8AB852DA
 * name thermostat
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermostat.svg
 * tags
 * - Device / Tech 
 * - Home Automation 
 */
export const NestIcon = ThermostatIcon;
export default NestIcon